<template>
    <div v-if="showModal">
        <b-modal
            v-model="showModalLocal"
            :title="'Выбор телефонного разговора'"
            class="modal-primary"
            size="lg"
            ok-variant="primary"
            @hide.prevent
            @ok="handleOk"
            @cancel="handleCancel"
            @close="handleCancel"
            ref="my-modal"
        >

            <v-server-table :url="apiurl('telecall/table-fu-fin')"  :columns="columns" :options="options" :theme="theme" id="telecallsTable" ref="telecallsTable"  class="table-sm">
            </v-server-table>

            <template slot="modal-footer" slot-scope="{ ok, cancel, close }">
                <b-button size="sm" variant="outline-secondary" @click="cancel()">
                    Закрыть
                </b-button>
                <b-button size="sm" variant="outline-success" @click="ok()">
                    Выбрать
                </b-button>
            </template>
        </b-modal>
    </div>
</template>


<script>
    import Vue from 'vue'
    import {ServerTable, Event} from 'vue-tables-2'
    import { functions } from '@/functions';
    import {CONSTANTS} from '@/constants'
    import type from '../views/nsb/jsx/telecalls/type.jsx'
    import event_type from '../views/nsb/jsx/telecalls/event_type.jsx'
    import record from '../views/nsb/jsx/telecalls/record.jsx'
    Vue.use(ServerTable)

    export default {
        name: 'TelecallSelectDialog',
        mixins: [functions],
        data: function () {
            return {
                columns: ['created_at', 'phone_number', 'type',  'record' ],
                options: {
                    saveState: true,
                    headings: {
                        created_at: 'дата/время',
                        phone_number: 'внешний',
                        type: 'тип звонка',
                        record: 'запись ',
                        record: ' ',
                    },
                    sortable: [],
                    filterable: ['phone_number', 'telephony_number',  'type', 'event_type'],
                    sortIcon: { base:'fa', up:'fa-sort-asc', down:'fa-sort-desc', is:'fa-sort' },
                    pagination: {
                        chunk: 10,
                        edge: false,
                        nav: 'scroll',
                        dropdown:false
                    },
                    templates: {
                        event_type,
                        type,
                        record
                    },
                    customFilters: [
                        'showtech',
                    ],
                    filterByColumn: true,
                    debounce: CONSTANTS.DEBOUNCE,
                    texts: CONSTANTS.DATA_TABLE_LANG,
                },
                theme: 'bootstrap4',
                template: 'default'
            };
        },
        model: {
            prop: "showModal",
            event: "hide"
        },
        props: {
            showModal: [Number, Boolean],
        },
        watch: {
        },
        methods: {
            handleCancel: function () {
                //console.log('SimpleDialog: handleCancel');
                this.$emit("hide", false);
            },
            handleOk: function () {
                //console.log('SimpleDialog: handleOk');
                this.$emit("hide", false);
            },
            handleSubmit: function () {
                //console.log('SimpleDialog: handleSubmit');
                this.$emit("hide", false);
            },
        },
        computed: {
            showModalLocal: {
                get: function () {
                    return this.showModal
                },
                set: function (newValue) {}
            }
        },
        created: function() {
            Event.$on('vue-tables.loading', ()=>{  });
            Event.$on('vue-tables.loaded',()=>{  });
        },
        mounted: function() {
            //console.log('SimpleDialog: mounted');
        },
        updated: function() {
            //console.log('SimpleDialog: updated');
        },
    }
</script>
